'use client'
import React, { useEffect, useRef, useState } from 'react'
import Image, { StaticImageData } from 'next/image'
import useOnMouseAndScroll from '@/shared/hooks/useOnMouseAndScroll'
import { PlaceholderValue } from 'next/dist/shared/lib/get-img-props'
import articlePlaceholder from '@/assets/images/placeholder/articlePlaceholder.svg'

type MyImageProps = {
  src: string | StaticImageData
  className?: string | undefined
  placeholderImage?: any
  height?: number | `${number}` | undefined
  width?: number | `${number}` | undefined
  loadOnScroll?: boolean
  alt?: string | undefined
  sizes?: string | undefined
  placeholder?: PlaceholderValue | undefined
  blurDataURL?: string | undefined
}

function MyImage({
  src,
  placeholderImage,
  loadOnScroll,
  className,
  alt,
  height,
  width,
  ...rest
}: MyImageProps) {
  const [url, setUrl] = useState(loadOnScroll ? placeholderImage || articlePlaceholder : src)
  const { isLoaded } = useOnMouseAndScroll()
  const wasError = useRef(false)

  useEffect(() => {
    setUrl(src)
  }, [src])

  useEffect(() => {
    if (loadOnScroll) {
      if (isLoaded) setUrl(src)
      else setUrl(placeholderImage || articlePlaceholder)
    } else if (!wasError.current) {
      setUrl(src)
    }
  }, [src, isLoaded])

  // function getUrl(): string | StaticImageData {
  // 	if (loadOnScroll) {
  // 		return isLoaded ? url : placeholderImage || ''
  // 	} else {
  // 		return url
  // 	}
  // }

  return (
    <Image
      className={className}
      src={url}
      height={height}
      width={width}
      quality={50}
      alt={alt || ''}
      onError={() => {
        wasError.current = true
        setUrl(placeholderImage || articlePlaceholder)
      }}
      unoptimized={true}
      {...rest}
    />
  )
}
export default React.memo(MyImage)
